import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export function storeCreator<S extends object>(store: StateCreator<S>) {
  return import.meta.env.NODE_ENV?.startsWith('development') ? create(devtools(store)) : create(store);
}
